
import CheckboxWithLabel from './CheckboxWithLabel.js';

export default CheckboxWithLabel